function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3312 5.17961V14.7359C15.3312 15.9046 14.3687 16.7984 13.2687 16.7984H5.22498C4.05623 16.7984 3.16248 15.8359 3.16248 14.7359V3.11711C3.16248 1.94836 4.12498 1.05461 5.22498 1.05461H11.2062L15.3312 5.17961Z",
  stroke: "#007BFF",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2062 1.05461V3.94211C11.2062 4.62961 11.7562 5.17961 12.4437 5.17961H15.3312",
  stroke: "#007BFF",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5125 16.8671V18.1046C12.5125 19.2734 11.55 20.1671 10.45 20.1671H2.40625C1.2375 20.1671 0.34375 19.2046 0.34375 18.1046V6.48586C0.34375 5.31711 1.30625 4.42336 2.40625 4.42336H3.1625",
  stroke: "#007BFF",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.675,
  height: 19.8,
  fill: "white",
  transform: "translate(0 0.710861)"
})));
function SvgIcnCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCopyIcon);
export default __webpack_public_path__ + "static/media/icn-copy-icon.e8b7c2966d11d0f4a888289033584d0a.svg";
export { ForwardRef as ReactComponent };